export default {
  MILESTONE_VALUES_CHANGED: 'MILESTONE_VALUES_CHANGED',
  SHOW_ALL_MILESTONES: 'SHOW_ALL_MILESTONES',
  CHANGE_DESCRIPTION_ROW: 'CHANGE_DESCRIPTION_ROW',
  CLEAR_SHIPPING_PRICE_VALUES: 'CLEAR_SHIPPING_PRICE_VALUES',
  NUM_MILESTONES: 10,
};
